import React, { useState } from "react";
import "./SupportTickets.css";
import { callMultipleApis } from "../../services/ApiServices";
import PageLoader from "../Assets/PageLoader/PageLoader";
import { AuthContext } from "../../Context/AuthContext";
import { useContext } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";


const fetchTickets = process.env.REACT_APP_FETCH_TICKETS_URL;
const submitTickets = process.env.REACT_APP_SUBMIT_TICKET_URL;

const SupportTickets = () => {
    const navigate = useNavigate();
    const { userDetails } = useContext(AuthContext);
    const [showForm, setShowForm] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [createdTicketNo, setCreatedTicketNo] = useState("");
    const [ticketList, setTicketList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [ticketForm, setTicketForm] = useState({
        category: "",
        subject: "",
        description: "",
    });

    useEffect(() => {
        fetchSupportList();
    }, []);


    const fetchSupportList = async () => {
        try {
            setLoading(true);

            const payload = {
                email: userDetails.emailid
            }

            const token = localStorage.getItem("auth-token");
            const config = { 'Authorization': `Bearer ${token}`, };

            const [res] = await callMultipleApis([
                {
                    url: fetchTickets,
                    method: "POST",
                    data: payload,
                    params: {},
                    headers: config,
                }
            ]);

            if (res.status === true) {
                setTicketList(res.result);
            }

        } catch (error) {
        } finally {
            setLoading(false);
        }
    }


    const handleTicketChange = (e) => {
        const { name, value } = e.target;

        setTicketForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    };


    const handleSubmitTicket = async (e) => {
        e.preventDefault();
        try {

            if (!ticketForm.category || !ticketForm.subject || !ticketForm.description) {
                alert("All fields are required");
                return;
            }


            setLoading(true);

            const payload = {
                email: userDetails.emailid,
                category: ticketForm.category,
                subject: ticketForm.subject,
                description: ticketForm.description,
            }

            const token = localStorage.getItem("auth-token");
            const config = { 'Authorization': `Bearer ${token}`, };

            const [res] = await callMultipleApis([
                {
                    url: submitTickets,
                    method: "POST",
                    data: payload,
                    params: {},
                    headers: config,
                }
            ]);

            if (res.status === true) {
                setTicketForm({
                    category: "",
                    subject: "",
                    description: "",
                });
                setShowForm(false);
                setCreatedTicketNo(res.result);
                setShowConfirmation(true);
                fetchSupportList();
            } else {
                alert(res.message);
            }
        } catch (error) {

        } finally {
            setLoading(false);
        }

    }





    return (
        <div className="support-page">
            <div className="support-container">

                {/* Header */}
                <div className="support-header">
                    <div>
                        <h1>Help & Support</h1>
                        <p className="subtitle">Manage your support tickets</p>
                    </div>

                    {ticketList.length > 0 && (<button className="create-ticket-btn" onClick={() => setShowForm(true)}>
                        + Create Ticket
                    </button>)}
                </div>

                {/* Tickets Section */}
                <div className="ticket-wrapper">
                    <h2>My Tickets</h2>

                    {ticketList.length === 0 ? (
                        <div className="empty-state">
                            <div className="empty-icon">🎫</div>
                            <p>No tickets raised yet</p>
                            <button className="create-ticket-btn" onClick={() => setShowForm(true)}>
                                Create Your First Ticket
                            </button>
                        </div>
                    ) : (
                        <div className="ticket-list">
                            {ticketList.map(ticket => (
                                <div className="ticket-card" key={ticket.ticket_id} /*onClick={() => navigate(`/support/${ticket.ticket_id}`)}*/>
                                    <div className="ticket-left">
                                        <h3>{ticket.subject}</h3>
                                        <p>
                                            {ticket.ticket_code} • {ticket.category} • {ticket.ticket_date}
                                        </p>
                                    </div>

                                    <span className={`status ${ticket.status.toLowerCase()}`}>
                                        {ticket.status}
                                    </span>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

            </div>

            {loading && (
                <PageLoader text="" />
            )}

            {/* Create Ticket Modal */}
            {showForm && (
                <div className="ticket-modal-overlay">
                    <div className="ticket-modal">
                        <h3>Create Support Ticket</h3>

                        <form onSubmit={handleSubmitTicket}>
                            <label>Category</label>
                            <select name="category" value={ticketForm.category} onChange={handleTicketChange}>
                                <option>Payment</option>
                                <option>Order</option>
                                <option>Profile</option>
                                <option>Technical</option>
                            </select>

                            <label>Subject</label>
                            <input type="text" name="subject" value={ticketForm.subject} onChange={handleTicketChange} placeholder="Enter subject" />

                            <label>Description</label>
                            <textarea name="description" value={ticketForm.description} onChange={handleTicketChange} placeholder="Describe your issue"></textarea>

                            <div className="ticket-actions">
                                <button
                                    type="button"
                                    className="cancel-btn"
                                    onClick={() => setShowForm(false)}
                                >
                                    Cancel
                                </button>
                                <button type="submit" className="submit-btn">
                                    Submit Ticket
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}


            {showConfirmation && (
                <div className="confirm-overlay">
                    <div className="confirm-modal">
                        <div className="confirm-icon">✅</div>

                        <h3>Ticket Created Successfully</h3>

                        <p>
                            Your support ticket has been created.<br />
                            <strong>Ticket No:</strong> {createdTicketNo}
                        </p>

                        <button
                            className="confirm-btn"
                            onClick={() => setShowConfirmation(false)}
                        >
                            OK
                        </button>
                    </div>
                </div>
            )}


        </div>
    );
};

export default SupportTickets;
